import { createReducer, on } from '@ngrx/store';
import { FlattenGraphQl } from 'src/app/utility';
import { CreateCustomerData, Customer, CustomerAccessToken, ShopifyError, Profile, MailingAddress } from '../../models';
import { Order, OrderLineItem } from '../../models/order.model';

import * as actions from '../actions/customer.action';
import * as utility from '../../../utility';
export interface CustomerState {
  registerSuccess: boolean;
  registering: boolean;
  token?: CustomerAccessToken;
  registerError?: ShopifyError[];
  customer: Customer | CreateCustomerData | undefined;
  signingIn: boolean;
  SignIngOut: boolean;
  customerLoading: boolean;
  customerLoaded: boolean;
  customerRecovering: boolean;
  customerRecovered: boolean;
  customerRecoveredErrors: ShopifyError[];
  customerUpdating: boolean;
  customerUpdated: boolean;
  customerUpdatingErrors: ShopifyError[];
  customerActivating: boolean;
  customerActivated: boolean;
  invitationSending: boolean;
  invitationSent: boolean;
  customerResetting: boolean;
  customerReset: boolean;
  tokenInitialized: boolean;
  tokenInitializing: boolean;
  errors?: any;
  loadingAsDefaultAddress?: string;
}

export const initialState: CustomerState = {
  registering: false,
  registerSuccess: false,
  customer: undefined,
  signingIn: false,
  SignIngOut: false,
  customerLoading: false,
  customerLoaded: false,
  customerUpdated: false,
  customerUpdating: false,
  customerRecovering: false,
  customerRecovered: false,
  customerActivated: false,
  customerActivating: false,
  customerResetting: false,
  customerReset: false,
  invitationSending: false,
  invitationSent: false,
  tokenInitializing: false,
  tokenInitialized: false,
  customerRecoveredErrors: [],
  customerUpdatingErrors: [],
};

export const customerReducer = createReducer(
  initialState,
  on(actions.LoadCustomer, (state: CustomerState) => {
    return {
      ...state,
      customerLoading: true,
      customerLoaded: false,
      errors: [],
    };
  }),
  on(actions.LoadCustomerSuccess, (state: CustomerState, { customer }) => {
    return {
      ...state,
      customer: customer ?? undefined,
      token: customer? state.token : undefined,
      customerLoading: false,
      customerLoaded: customer ? true : false,
      errors: [],
    };
  }),
  on(actions.LoadCustomerFail, (state: CustomerState, { errors }) => {
    return {
      ...state,
      customerLoading: false,
      customerLoaded: false,
      registerError: errors,
    };
  }),
  on(actions.CreateCustomer, (state: CustomerState) => {
    return {
      ...state,
      registering: true,
      registerSuccess: false,
      registerError: [],
    };
  }),
  on(actions.CreateCustomerSuccess, (state: CustomerState, { customer }) => {
    return {
      ...state,
      customer,
      registering: false,
      registerSuccess: true,
      registerError: [],
    };
  }),
  on(actions.CreateCustomerFail, (state: CustomerState, { errors }) => {
    return {
      ...state,
      registering: false,
      registerSuccess: false,
      registerError: errors,
    };
  }),
  on(actions.CreateCustomerAccessToken, (state: CustomerState, { data }) => {
    return {
      ...state,
      signingIn: true,
      token: undefined,
    };
  }),
  on(actions.InitCustomerAccessToken, (state: CustomerState, {}) => {
    return {
      ...state,
      tokenInitializing: true,
      tokenInitialized: false,
    };
  }),
  on(actions.CreateCustomerAccessTokenSuccess, actions.InitCustomerAccessTokenSuccess, (state: CustomerState, { token }) => {
    return {
      ...state,
      token,
      signingIn: false,
      tokenInitialized: true,
      tokenInitializing: false,
      // error: auth.error,
    };
  }),
  on(actions.CreateCustomerAccessTokenFail, (state: CustomerState, { errors }) => {
    return {
      ...state,
      customer: undefined,
      signingIn: false,
      errors,
      expiresAt: null,
    };
  }),
  on(actions.RecoverCustomer, (state: CustomerState, { email }) => {
    return {
      ...state,
      customerRecovered: false,
      customerRecovering: true,
      customerRecoveredErrors: [],
    };
  }),
  on(actions.RecoverCustomerSuccess, (state: CustomerState) => {
    return {
      ...state,
      customerRecovered: true,
      customerRecovering: false,
    };
  }),
  on(actions.RecoverCustomerFail, (state: CustomerState, { errors }) => {
    return {
      ...state,
      customerRecovered: false,
      customerRecovering: false,
      customerRecoveredErrors: errors,
    };
  }),
  on(actions.DeleteCustomerAccessToken, (state: CustomerState) => {
    return {
      ...state,
      SignIngOut: true,
    };
  }),
  on(actions.DeleteCustomerAccessTokenSuccess, (state: CustomerState) => {
    return {
      ...state,
      customer: undefined,
      signingIn: false,
      SignIngOut: false,
      token: undefined,
      error: null,
    };
  }),
  on(actions.DeleteCustomerAccessTokenFail, (state: CustomerState, { errors }) => {
    return {
      ...state,
      SignIngOut: false,
      errors,
    };
  }),
  on(actions.ActivateCustomer, (state: CustomerState) => {
    return {
      ...state,
      customerActivating: true,
      customerActivated: false,
      error: null,
    };
  }),
  on(actions.ActivateCustomerSuccess, (state: CustomerState, { result }) => {
    return {
      ...state,
      token: result.customerAccessToken,
      signingIn: false,
      tokenInitialized: true,
      tokenInitializing: false,
      customerActivated: true,
      customerActivating: false,
      error: null,
    };
  }),
  on(actions.ActivateCustomerFail, (state: CustomerState, { errors }) => {
    return {
      ...state,
      customerActivated: false,
      customerActivating: false,
      errors,
    };
  }),
  on(actions.UpdateCustomer, (state: CustomerState) => {
    return {
      ...state,
      customerUpdating: true,
      customerUpdated: false,
      customerUpdatingErrors: [],
    };
  }),
  on(actions.UpdateCustomerSuccess, (state: CustomerState, { customer }) => {
    return {
      ...state,
      customer: {
        ...state.customer,
        ...customer,
      },
      customerUpdated: true,
      customerUpdating: false,
      customerUpdatingErrors: [],
    };
  }),
  on(actions.UpdateCustomerFail, (state: CustomerState, { errors }) => {
    return {
      ...state,
      customerUpdated: false,
      customerUpdating: false,
      customerUpdatingErrors: errors,
    };
  }),

  on(actions.ResetCustomer, (state: CustomerState) => {
    return {
      ...state,
      customerResetting: true,
      customerReset: false,
      errors: [],
    };
  }),
  on(actions.ResetCustomerSucces, (state: CustomerState) => {
    return {
      ...state,
      customerReset: true,
      customerResetting: false,
      errors: [],
    };
  }),
  on(actions.ResetCustomerFail, (state: CustomerState, { errors }) => {
    return {
      ...state,
      customerReset: false,
      customerResetting: false,
      errors,
    };
  }),
  on(actions.SetDefaultAddress, (state: CustomerState, { id }) => {
    return {
      ...state,
      loadingAsDefaultAddress: id,
    };
  }),
  on(actions.SetDefaultAddressSuccess, (state: CustomerState, { address }) => {
    return {
      ...state,
      customer: { ...(state.customer as Customer), defaultAddress: address },
      loadingAsDefaultAddress: undefined,
    };
  }),
  on(actions.SendInvitation, (state: CustomerState) => {
    return {
      ...state,
      invitationSending: true,
      invitationSent: false,
    };
  }),
  on(actions.SendInvitationSuccess, (state: CustomerState, { success }) => {
    return {
      ...state,
      invitationSent: success,
      invitationSending: false,
    };
  })
);

export const getAuthUser = (state: CustomerState) => state.customer;
export const getCustomerSigningIn = (state: CustomerState) => state.signingIn;
export const getAuthError = (state: CustomerState) => state.errors;
export const getUser = (state: CustomerState) => state.customer;

export const getCustomerAccessToken = (state: CustomerState) => state.token;

export const getRegistering = (state: CustomerState) => state.registering;
export const getRegisterSuccess = (state: CustomerState) => state.registerSuccess;
export const getRegisterError = (state: CustomerState) => state.registerError;

export const getCustomer = (state: CustomerState) => state.customer;
export const getCustomerLoaded = (state: CustomerState) => state.customerLoaded;
export const getCustomerLoading = (state: CustomerState) => state.customerLoading;

export const getCustomerActivated = (state: CustomerState) => state.customerActivated;
export const getCustomerActivating = (state: CustomerState) => state.customerActivating;

export const getCustomerReset = (state: CustomerState) => state.customerReset;
export const getCustomerResetting = (state: CustomerState) => state.customerResetting;
export const getCustomerResetErrors = (state: CustomerState) => state.errors;

export const getCustomerUpdated = (state: CustomerState) => state.customerUpdated;
export const getCustomerUpdating = (state: CustomerState) => state.customerUpdating;
export const getCustomerUpdatingErrors = (state: CustomerState) => state.customerUpdatingErrors;

export const getTokenInitialized = (state: CustomerState) => state.tokenInitialized;
export const getTokenInitializing = (state: CustomerState) => state.tokenInitializing;

export const getInvitationSent = (state: CustomerState) => state.invitationSent;
export const getInvitationSending = (state: CustomerState) => state.invitationSending;

export const getCustomerRecovering = (state: CustomerState) => state.customerRecovering;
export const getCustomerRecovered = (state: CustomerState) => state.customerRecovered;
export const getCustomerRecoveredErrors = (state: CustomerState) => state.customerRecoveredErrors;

export const getLoadingAsDefaultAddress = (state: CustomerState) => state.loadingAsDefaultAddress;
